import { Skeleton } from "@/components/shadcn/ui/skeleton";
import { PageSection } from "./PageSection";

export const PageLoader = () => {
  return (
    <PageSection>
      <div className="w-full flex flex-col gap-2">
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5" />

        <div className="mt-8 space-y-4">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      </div>
    </PageSection>
  );
};
